import React, { createContext, useContext, ReactNode } from 'react';
import { AnalyticsService } from './AnalyticsService';
import { AnalyticsCompositor } from './AnalyticsCompositor';
import { GoogleAnalyticsService } from './GoogleAnalyticsService';
import { EventCollectorService } from './event-collector';

const analyticsService: AnalyticsService = new AnalyticsCompositor(
  new GoogleAnalyticsService(),
  new EventCollectorService()
);
analyticsService.init();

const adStackAnalyticsService: AnalyticsService = new AnalyticsCompositor(
  new EventCollectorService('fotoscapes-player-ad-stack')
);
adStackAnalyticsService.init();

const AnalyticsContext = createContext<AnalyticsService | undefined>(undefined);
const AdStackAnalyticsContext = createContext<AnalyticsService | undefined>(undefined);

export const AnalyticsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <AnalyticsContext.Provider value={analyticsService}>
      <AdStackAnalyticsContext.Provider value={adStackAnalyticsService}>
        {children}
      </AdStackAnalyticsContext.Provider>
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = (): AnalyticsService => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};

export const useAdStackAnalytics = (): AnalyticsService => {
  const context = useContext(AdStackAnalyticsContext);
  if (context === undefined) {
    throw new Error('useAdStackAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
